import JoinIntegration from 'app/developer-v3/pages/joinIntegration';

export default {
  isAuthRequired: true,
  routes: {
    '.': JoinIntegration,
  },
};
